
import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import * as ReactRouterDOM from 'react-router-dom';
import { ShieldCheck, Lock, ArrowRight, Loader } from 'lucide-react';

const { useNavigate } = ReactRouterDOM as any;

const AdminLogin: React.FC = () => {
  const { login, config } = useApp();
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const result = await login(token);
    
    setLoading(false);
    if (result.success) {
      navigate('/'); // Redirect to home with edit mode enabled
    } else {
      setError(result.error || 'Wystąpił nieznany błąd.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-md animate-fade-in-up">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-black text-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
            <ShieldCheck size={32} />
          </div>
          <h1 className="text-2xl font-serif font-bold text-gray-900">Panel Administratora</h1>
          <p className="text-gray-500 text-xs uppercase tracking-widest mt-2">{config.companyName}</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-2">Token Dostępu</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-3 text-gray-400" />
              <input 
                type="password" 
                value={token}
                onChange={(e) => { setToken(e.target.value); setError(''); }}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent outline-none transition-all"
                placeholder="Wpisz token..."
                autoFocus
              />
            </div>
            {error && (
                <div className="mt-2 bg-red-50 text-red-600 p-3 rounded text-xs font-medium border border-red-200">
                    {error}
                </div>
            )}
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-black text-white py-4 rounded-lg font-bold text-sm uppercase tracking-widest hover:bg-gray-800 transition-all flex items-center justify-center gap-2 group disabled:opacity-70 disabled:cursor-wait"
          >
            {loading ? <Loader className="animate-spin" size={16} /> : (
                <>Zaloguj się <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" /></>
            )}
          </button>
        </form>

        <div className="mt-8 text-center">
            <p className="text-[10px] text-gray-400">
                Sesja wygasa automatycznie po 5 minutach bezczynności.
            </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
